import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsScreenFailKey,
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsClinicalScreenFailTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.INVESTIGATOR.INDEX;
  subRoute = ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_TRANSACTIONS;

  createTable = (
    selectedKey: TrialInsightsScreenFailKey = TrialInsightsScreenFailKey.NUMBER,
    rowData: TrialInsightsTableRowData[] = []
  ): TrialInsightsTableOptions => {
    return {
      buttons: {
        data: [
          { key: 'number', value: '# Screen Fails' },
          { key: 'percent', value: '% Screen Fails' },
        ],
        defaultButtonKey: selectedKey,
        display: true,
      },
      header: {
        data: [
          { buttonKey: 'number', leftValue: 'Site', rightValue: 'Screen Fails' },
          { buttonKey: 'percent', leftValue: 'Site', rightValue: 'Screen Fails' },
        ],
        display: true,
      },
      link: {
        display: true,
        url: `/${this.route}/${this.subRoute}`,
        value: 'Investigator Transactions',
      },
      rowData: {
        compact: false,
        data: rowData,
      },
    };
  };
}
